import React from "react";
import { Modal, Typography, Card, Box, Grid, IconButton, Icon, Button, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CancelIcon from "../../../icons/cancelIcon.svg";
import RoundBackIcon from "../../../icons/RoundBackIcon.svg";
import NumberFormat from "react-number-format";
import DialogTermsAndConditions from "../../payments/components/DialogTermsAndConditions";

const useStyles = makeStyles({
  modalContainer: {
    background: "#FFFFFF",
    boxShadow: "none",
    borderRadius: "24px",
  },
  cardSytle: {
    position: "relative" as "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    padding: "16px",
    pointerEvents: "auto",
    width: '98%',
    maxWidth: '472px',
    minHeight: '523px',
    borderRadius: '24px',
    outline: 'none',
  },
  titleText: {
    fontFamily: "Work Sans !important",
    fontStyle: "normal !important",
    fontWeight: "600 !important",
    fontSize: "18px !important",
    lineHeight: "22px !important",
    color: "#000000 !important",
    textAlign: "center",
  },
  reviewAndSubmitMainDetails: {
    marginBottom: "18px",
  },
  termsAndConditionLink: {
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "#39A2DB !important",
    marginTop: "18px",
    cursor: "pointer",
  },
  buttonContainer: {
    position: "absolute",
    bottom: "20px",
    marginLeft: "calc( 50% - 100px )",
  },
  globalError: {
    display: "flex",
    flexDirection: "row",
    borderTop: "2px  solid #DB3939",
    borderRadius: "24px",
    padding: "12px 20px",
    width: "100%",
    height: "49px",
    marginTop: "24px",
  },
});

interface ApplicationReviewModalProps {
  open: boolean;
  propertyName: string;
  companyName: string;
  applicantName: string;
  paidAmount: number;
  totalAmount: number;
  transactionDate: string;
  paymentFees: number;
  last4: string;
  globalError?: string;
  closeCallback: () => void;
  backCallback: () => void;
  confirmCallback: () => void;
}

export default function ApplicationReviewModal(props: ApplicationReviewModalProps) {
  const classes = useStyles();
  const [openLegaleseDialog, setOpenLegaleseDialog] = React.useState(false);
  const [openFeesDialog, setOpenFeesDialog] = React.useState(false);

  const handleCloseLegaleseDialog = () => setOpenLegaleseDialog(false);
  const handleCloseFeesDialog = () => setOpenFeesDialog(false);
  const handleLegaleseClick = () => setOpenLegaleseDialog(true);
  const handleFeesClick = () => setOpenFeesDialog(true);

  return (
    <div className={`${classes.modalContainer}`}>
      <Modal
        open={props.open}
        onClose={(e, reason) => reason !== 'backdropClick' && props.closeCallback()}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        BackdropProps={{
          invisible: false,
        }}
        disableEscapeKeyDown
      >
        <Card className={classes.cardSytle}>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
            <Box sx={{ position: 'absolute', left: 0, top: 0 }}>
              <IconButton onClick={() => props.backCallback()}>
                <Icon>
                  <img src={RoundBackIcon} alt="Back" width={24} height={24} />
                </Icon>
              </IconButton>
            </Box>
            <Typography className={classes.titleText} sx={{ mt: 1 }}>
              Review And Submit
            </Typography>
            <Box sx={{ position: 'absolute', right: 0, top: 0 }}>
              <IconButton sx={{ mr: "-6px"  }} onClick={() => props.closeCallback()}>
                <Icon>
                  <img src={CancelIcon} alt="Close" width={24} height={24} />
                </Icon>
              </IconButton>
            </Box>
          </Box>

          {props.globalError?.length ? (
            <div className={classes.globalError}>
              <Typography
                style={{
                  fontFamily: "'Open Sans', sans-serif",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "14px",
                  lineHeight: "18px",
                  color: "#DB3939",
                }}
              >
                {props.globalError}
              </Typography>
            </div>
          ) : (
            <></>
          )}

          <Box sx={{ width: "100%", mt: 3, mb: 8 }}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} position={"relative"}>
              <Grid item xs={6}>
                <div>
                  <Typography
                    style={{
                      color: "#14142B",
                      fontSize: "16px",
                    }}
                    id="review-submit-main-details"
                  >
                    {props.companyName.length > 20 ? `${props.companyName.slice(0, 20)}...`: props.companyName}
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={6}>
                <div>
                  <Typography
                    style={{
                      color: "#14142B",
                      fontSize: "16px",
                    }}
                    id="review-submit-main-details"
                  >
                    {props.propertyName.length > 20 ? `${props.propertyName.slice(0, 20)}...`: props.propertyName}
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={6}>
                <div className={classes.reviewAndSubmitMainDetails}>
                  <Typography
                    style={{
                      color: "#14142B",
                      fontSize: "16px",
                    }}
                    id="review-submit-main-details"
                  >
                    {props.applicantName.length > 20 ? `${props.applicantName.slice(0, 20)}...`: props.applicantName}
                  </Typography>
                </div>
              </Grid>
            </Grid>
            <Divider sx={{ mx: '-16px' }} />
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} sx={{ marginTop: "5px" }}>
              <Grid item xs={8}>
                <div>
                  <Typography id="review-submit-bank-details-text">Payment Method</Typography>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div>
                  <Typography id="review-submit-sub-bank-details" sx={{ fontWeight: 400 }}>{props.last4}</Typography>
                </div>
              </Grid>
              <Grid item xs={8}>
                <div>
                  <Typography id="review-submit-sub-details">Amount</Typography>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div>
                  <Typography id="review-submit-sub-details" sx={{ fontWeight: 400 }}>
                    <NumberFormat thousandsGroupStyle="thousand" value={props.paidAmount / 100} prefix="$" decimalSeparator="." displayType="text" type="text" thousandSeparator={true} allowNegative={true} decimalScale={2} fixedDecimalScale={true} />
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={8}>
                <div>
                  <Typography id="review-submit-sub-details">Fee Amount</Typography>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div>
                  <Typography id="review-submit-sub-details" sx={{ fontWeight: 400 }}>
                    <NumberFormat thousandsGroupStyle="thousand" value={props.paymentFees / 100} prefix="$" decimalSeparator="." displayType="text" type="text" thousandSeparator={true} allowNegative={true} decimalScale={2} fixedDecimalScale={true} />
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={8}>
                <div>
                  <Typography id="review-submit-sub-details">Total Amount</Typography>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div>
                  <Typography id="review-submit-sub-details" sx={{ fontWeight: 400 }}>
                    <NumberFormat thousandsGroupStyle="thousand" value={props.totalAmount / 100} prefix="$" decimalSeparator="." displayType="text" type="text" thousandSeparator={true} allowNegative={true} decimalScale={2} fixedDecimalScale={true} />
                  </Typography>
                </div>
              </Grid>
              <Grid item xs={8}>
                <div>
                  <Typography id="review-submit-sub-details">Transaction Date</Typography>
                </div>
              </Grid>
              <Grid item xs={4}>
                <div>
                  <Typography id="review-submit-sub-details" sx={{ fontWeight: 400 }}>{props.transactionDate}</Typography>
                </div>
              </Grid>
            </Grid>
            <Box sx={{ mt: 3 }}>
              <Typography variant="body2" gutterBottom id="terms-and-condition">
                By Clicking Submit you agree to our{" "}
                <span
                  className={classes.termsAndConditionLink}
                  onClick={() => {
                    window.open("/terms");
                  }}
                >
                  {"T&Cs..."}
                </span>
              </Typography>
              <Typography variant="body2" gutterBottom id="terms-and-condition">
                Fraudulent Payment will be prosecuted to the {" "}
                <span className={classes.termsAndConditionLink} onClick={handleLegaleseClick}>
                  fullest extent…
                </span>
              </Typography>
              <Typography variant="body2" gutterBottom id="terms-and-condition">
                Payments resulting in Returns or Chargebacks may incur{" "}
                <span className={classes.termsAndConditionLink} onClick={handleFeesClick}>
                  additional fees.
                </span>
              </Typography>
            </Box>
            <DialogTermsAndConditions openState={openLegaleseDialog} handleClose={handleCloseLegaleseDialog} default={true} />
            <DialogTermsAndConditions openState={openFeesDialog} handleClose={handleCloseFeesDialog} default={false} />
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'flex-end', position: 'absolute', bottom: 12, right: 19 }}>
            <Button
              sx={{ '&.Mui-disabled': {
                color: '#fff'
              } }}
              onClick={props.confirmCallback}
              variant="contained"
              id="payment-modal-btn"
            >
              Submit
            </Button>
          </Box>
        </Card>
      </Modal>
    </div>
  );
}
